import { Injectable, signal, OnDestroy } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NetworkStatusService implements OnDestroy {
  // Signal for online/offline status
  private _isOnline = signal<boolean>(typeof navigator !== 'undefined' ? navigator.onLine : true);

  // Public readonly signal
  public readonly isOnline = this._isOnline.asReadonly();

  // Keep references to event handlers so they can be removed on destroy
  private readonly onlineHandler = () => {
    this._isOnline.set(true);
  };

  private readonly offlineHandler = () => {
    this._isOnline.set(false);
  };

  constructor() {
    // Only set up listeners in browser environment
    if (typeof window !== 'undefined') {
      this.setupListeners();
    }
  }

  ngOnDestroy(): void {
    // Clean up event listeners if the service is ever destroyed
    if (typeof window !== 'undefined') {
      window.removeEventListener('online', this.onlineHandler);
      window.removeEventListener('offline', this.offlineHandler);
    }
  }

  private setupListeners(): void {
    // Listen to online event
    window.addEventListener('online', this.onlineHandler);

    // Listen to offline event
    window.addEventListener('offline', this.offlineHandler);
  }
}
